export default {
	showViewErrors: false,
	errorLogList:{
        data: null,
        links: null,
        meta: null
    },
}
